import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { RedImmobile, RedFinanziamento } from '../../../types/red'
import { TIPI_FINANZIAMENTO_LABEL, STATO_FINANZIAMENTO_CONFIG, EUR } from '../../../constants/red'
import { redApi } from '../../../services/api'

const TabFinanziamenti: React.FC<{ immobile: RedImmobile; onUpdate: () => void }> = ({ immobile, onUpdate }) => {
  const [finanziamenti, setFinanziamenti] = useState<RedFinanziamento[]>([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ tipo: 'debito_bancario', istituto: '', importo: '', tasso_interesse: '', data_erogazione: '', data_scadenza: '', note: '' })

  const load = () => {
    redApi.finanziamenti.listByImmobile(immobile.id).then(res => {
      setFinanziamenti(res.data)
      setLoading(false)
    })
  }

  useEffect(load, [immobile.id])

  const handleCreate = async () => {
    if (!form.importo) { toast.error('Importo obbligatorio'); return }
    try {
      await redApi.finanziamenti.create({
        immobile_id: immobile.id,
        tipo: form.tipo,
        istituto: form.istituto || null,
        importo: parseFloat(form.importo),
        tasso_interesse: form.tasso_interesse ? parseFloat(form.tasso_interesse) : null,
        data_erogazione: form.data_erogazione || null,
        data_scadenza: form.data_scadenza || null,
        note: form.note || null,
      })
      toast.success('Finanziamento aggiunto')
      setForm({ tipo: 'debito_bancario', istituto: '', importo: '', tasso_interesse: '', data_erogazione: '', data_scadenza: '', note: '' })
      setShowForm(false)
      load()
      onUpdate()
    } catch { toast.error('Errore creazione') }
  }

  if (loading) return <div className="text-gray-400">Caricamento...</div>

  const totale = finanziamenti.reduce((s, f) => s + (f.importo || 0), 0)

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-800">Capital Stack</h2>
          <p className="text-sm text-gray-500">Totale finanziamenti: {EUR.format(totale)}</p>
        </div>
        <button onClick={() => setShowForm(v => !v)} className="btn-primary text-sm">+ Aggiungi</button>
      </div>

      {showForm && (
        <div className="card p-4 mb-4 grid grid-cols-3 gap-3">
          <div><label className="label">Tipo</label>
            <select className="select" value={form.tipo} onChange={e => setForm({...form, tipo: e.target.value})}>
              {Object.entries(TIPI_FINANZIAMENTO_LABEL).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <div><label className="label">Istituto</label><input className="input" value={form.istituto} onChange={e => setForm({...form, istituto: e.target.value})} /></div>
          <div><label className="label">Importo (€)</label><input type="number" className="input" value={form.importo} onChange={e => setForm({...form, importo: e.target.value})} /></div>
          <div><label className="label">Tasso %</label><input type="number" step="0.01" className="input" value={form.tasso_interesse} onChange={e => setForm({...form, tasso_interesse: e.target.value})} /></div>
          <div><label className="label">Erogazione</label><input type="date" className="input" value={form.data_erogazione} onChange={e => setForm({...form, data_erogazione: e.target.value})} /></div>
          <div><label className="label">Scadenza</label><input type="date" className="input" value={form.data_scadenza} onChange={e => setForm({...form, data_scadenza: e.target.value})} /></div>
          <div className="col-span-3"><label className="label">Note</label><input className="input" value={form.note} onChange={e => setForm({...form, note: e.target.value})} /></div>
          <div className="col-span-3"><button onClick={handleCreate} className="btn-primary text-sm">Salva</button></div>
        </div>
      )}

      <div className="space-y-2">
        {finanziamenti.map(fin => {
          const cfg = STATO_FINANZIAMENTO_CONFIG[fin.stato]
          return (
            <div key={fin.id} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-3">
              <div>
                <div className="text-sm font-medium text-gray-800">{TIPI_FINANZIAMENTO_LABEL[fin.tipo] || fin.tipo} — {fin.istituto || 'N/D'}</div>
                <div className="text-xs text-gray-400">
                  {fin.data_erogazione && `Erogato: ${new Date(fin.data_erogazione).toLocaleDateString('it-IT')}`}
                  {fin.data_scadenza && ` · Scadenza: ${new Date(fin.data_scadenza).toLocaleDateString('it-IT')}`}
                  {fin.tasso_interesse != null && ` · Tasso: ${fin.tasso_interesse}%`}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-semibold">{EUR.format(fin.importo)}</span>
                <span className="text-xs font-medium px-2 py-0.5 rounded-full" style={{ color: cfg.color, backgroundColor: '#f3f4f6' }}>{cfg.label}</span>
                <button onClick={async () => { if (!confirm('Eliminare?')) return; await redApi.finanziamenti.delete(fin.id); toast.success('Eliminato'); load(); onUpdate() }} className="text-xs text-red-500 hover:text-red-700">🗑</button>
              </div>
            </div>
          )
        })}
        {finanziamenti.length === 0 && <div className="text-center py-10 text-gray-400">Nessun finanziamento registrato.</div>}
      </div>
    </div>
  )
}

export default TabFinanziamenti
